import { smartQueue } from "../utils/queue.js";
import { getTenantNamespace } from "../app-config/index.js";
const CHRONOSPHERE_LOGS_INGEST_ENDPOINT = '/api/unstable/data/logs/forward';
const CLOUD_UI_LOGGING_SERVICE = 'cloud-ui-browser';
class ChronosphereLogsClient {
    url;
    service;
    identifyPayload;
    _logQueue;
    _enabled;
    _lastPathname;
    _sessionData;
    constructor(url){
        this.url = url || CHRONOSPHERE_LOGS_INGEST_ENDPOINT;
        this.service = CLOUD_UI_LOGGING_SERVICE;
        this.identifyPayload = {};
        this._enabled = false;
        this._logQueue = smartQueue((events)=>{
            this._flushLogs(events);
        }, {
            max: 10,
            interval: 3000,
            throttle: true
        });
    }
    page() {
        if (this._lastPathname === window.location.pathname) return;
        const pathname = window.location.pathname;
        this.submitLog({
            message: '[page_view] ' + pathname,
            event_name: 'page_view',
            previous_page_url: this._lastPathname
        });
        this._lastPathname = pathname;
    }
    identify(userId, payload) {
        this._enabled = true;
        this.identifyPayload = {
            user_id: userId,
            ...payload
        };
        if ('string' == typeof this.identifyPayload.email && !this.identifyPayload.email.includes('@chronosphere.io')) delete this.identifyPayload.email;
        this.page();
    }
    track(eventName, payload) {
        this.submitLog({
            message: '[event] ' + eventName,
            event_name: eventName,
            ...payload
        });
    }
    submitLog(log) {
        const tenantName = getTenantNamespace();
        const payload = {
            happened_at: new Date().toISOString(),
            ...log,
            ...this.identifyPayload,
            ...this._getPageInfo(),
            ...this._sessionData,
            'resource.type': 'browser',
            'resource.labels.namespace_name': tenantName,
            tenant_name: tenantName,
            service: this.service,
            level: log.level ?? 'info'
        };
        this._logQueue.push(payload);
    }
    setSessionData(data) {
        this._sessionData = data;
    }
    _flushLogs(logs) {
        if (!this._enabled || 'development' === process.env.NODE_ENV) return;
        const payload = logs.map((e)=>JSON.stringify(e)).join('\n');
        try {
            fetch(this.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: payload
            });
        } catch (e) {
            console.error('Failed to send logs to Chronosphere', e);
        }
    }
    _getPageInfo() {
        return {
            page_title: document.title,
            page_url: window.location.href
        };
    }
}
const chronosphereLogsClient = new ChronosphereLogsClient();
export { CHRONOSPHERE_LOGS_INGEST_ENDPOINT, CLOUD_UI_LOGGING_SERVICE, ChronosphereLogsClient, chronosphereLogsClient };

//# sourceMappingURL=chronosphere-logs.js.map